import { CommonResponse, get } from './common.ts'

// GET /admin/profile

interface GetAdminProfileResponse {}

export const getUserProfile = async (): Promise<CommonResponse<GetAdminProfileResponse>> => {
  return await get('/admin/profile')
}
